import { render, staticRenderFns } from "./MembershipCreate.vue?vue&type=template&id=1284a0f3&"
import script from "./MembershipCreate.vue?vue&type=script&lang=ts&"
export * from "./MembershipCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports